<div
    [ngClass]="[
        'ua-' + deviceService.browser,
        'os-' + deviceService.os,
        'dt-' + deviceService.deviceType
    ]"
>
    <router-outlet></router-outlet>
    <bazis-modals></bazis-modals>
    <app-alert></app-alert>
    <bazis-context-menus></bazis-context-menus>
    <bazis-toast></bazis-toast>
    <bazis-global-loader loader="dots" hasBackdrop="true"></bazis-global-loader>
</div>
